const renderElement = value => {
  return {
    __html: value,
  }
}
export default renderElement
